const NotificationStore = {
  namespaced: true,
  state: () => ({}),
  mutations: {},
  actions: {
    async EnviarNotificaciones(
      // eslint-disable-next-line no-unused-vars
      { commit },
      { registration_ids, title, message, url = "" }
    ) {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");

      console.log({ store: "notificacion", registration_ids });

      if (registration_ids.length <= 0) {
        return;
      }

      const dominio =
        process.env.VUE_APP_AMBIENTE === "sandbox"
          ? "https://sandbox.digipats.com.co"
          : "https://digipats.com.co";
      const ambiente =
        process.env.VUE_APP_AMBIENTE === "sandbox"
          ? process.env.VUE_APP_CLOUDFUNCTIONURL_SANDBOX
          : process.env.VUE_APP_CLOUDFUNCTIONURL;
      const urlEnvio = `${ambiente}/enviarNotificacionFcm`;

      const body = JSON.stringify({
        tokens: [...registration_ids],
        message: {
          notification: {
            title,
            body: message,
          },
          data: {
            ...(url ? { url } : { url: dominio }),
          },
        },
      });

      const requestOptions = {
        method: "POST",
        headers,
        body,
        redirect: "follow",
      };
      await fetch(urlEnvio, requestOptions)
        .then((response) => response.json())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error));
    },
  },
  getters: {},
};

export default NotificationStore;
